// Frontend error monitoring + performance tracing via Sentry.
//
// The DSN is a client-side, write-only value that ships in the bundle (like the
// Google Maps keys), not a secret. initSentry no-ops when VITE_SENTRY_DSN is
// unset, so local dev sends nothing.
//
// @sentry/vue auto-installs a Vue error handler that chains to the existing
// app.config.errorHandler (report-error.js), call initSentry AFTER that handler
// is assigned so the chain is preserved. Session replay is intentionally not
// enabled.
import * as Sentry from '@sentry/vue'

export function initSentry(app, router) {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.MODE, // 'staging' | 'production'
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 1.0, // internal-scale app; free tier easily covers it
  })
}

export { Sentry }
